import { connect } from 'react-redux'
import { push } from 'connected-react-router'

import { getShowUserOutOfOfficeBlock } from 'store/entities/identity/selectors'
import UserOutOfOfficeBlock from './UserOutOfOfficeBlock'

const mapStateToProps = state => ({
  show: getShowUserOutOfOfficeBlock(state),
})

const mapDispatchToProps = {
  goToOutOfOffice: () => push('/profile/out-of-office'),
}

export default connect(mapStateToProps, mapDispatchToProps)(UserOutOfOfficeBlock)
